import { useEffect, useState } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let partnerOptions = [];

function UserPartnerTableRow({ key, loginId, partners, handleSubmit, setError, t, setAdd, oddIdx }) {
	const [partnerLoaded, setPartnerLoaded] = useState(false);
	const [partnerSelected, setPartnerSelected] = useState({ name: "partnerKey", label: "", value: 0, color: "" });
	const [isSubmit, setIsSubmit] = useState(false);
	const today = new Date().toISOString().split("T")[0];
	const [dates, setDates ] = useState({startDate:today, endDate:""});
	
	useEffect(() => {
		setPartnerValues(partners);
	}, []);

	function setPartnerValues(partnerObj) {
		let partnerValue = {};
		partnerOptions = [];
		if (partnerObj && partnerObj.length > 0) {
			partnerObj.map((aPartner, idx) => {
				partnerValue.label = aPartner.companyName;
				partnerValue.value = aPartner.companyId;
				partnerValue.color = aPartner.status === "Expired" ? "grey" : aPartner.status === 'In-Active' ? "red" : '';
				partnerOptions.push(partnerValue);
				if (idx == 0) {
					setPartnerSelected({ ...partnerSelected, label: (aPartner.companyName), value: aPartner.companyId});
				}
				partnerValue = {};
			});
			setPartnerLoaded(true);
		}
	}
	const partnerHandler = (selectedOption, action) => {
		let companyId = selectedOption ? selectedOption.value : 0;
		let companyName = selectedOption ? selectedOption.label : "";
		setPartnerSelected({ ...partnerSelected, label: (companyName), value: companyId });
	}

	const onResponseChange = (event) => {
		const { name, value } = event.target;
		if(typeof value === 'undefined'){
			value="";
		}
    	setDates({ ...dates, [name]: value });
	}

	function submitComplete() {
		setIsSubmit(false);
	}
	const validateFields = () => {
		const errors = [];
		let date1;
		let date2;
		if (!partnerSelected.value || partnerSelected.value === 0) {
			errors.push(t("error.suplrReqd"));
		}

		if(!dates.startDate){
			errors.push(t("error.startdateReqd"));
		}
		
		if(dates.endDate){
			if(dates.startDate instanceof Object){
				date1 = dates.startDate.getTime();
			} else {
				date1 = new Date(dates.startDate).getTime();
			}
			if(dates.endDate instanceof Object){
				date2 = dates.endDate.getTime();
			} else {
				date2 = new Date(dates.endDate).getTime();
			}
			if (date1 > date2) {
		    	errors.push(t("error.endDateBeforeStartDate"));
		  	} 
		}
		return errors;
	};
	function submitRow() {
		setError("");
		setIsSubmit(true);
		let errors = validateFields();
		let startDateValue = dates.startDate;
		let endDateValue = dates.endDate;
		let dateObj;
		if(dates.startDate instanceof Object){
			dateObj = dates.startDate;
		} else {
			dateObj = new Date(dates.startDate);
		}
		startDateValue = [
						  	dateObj.getFullYear(),
						  	('0' + (dateObj.getMonth() + 1)).slice(-2),
						  	('0' + dateObj.getDate()).slice(-2)
						].join('-');

		if(dates.endDate){
			if( dates.endDate instanceof Object){
				dateObj = dates.endDate;
			} else {
				dateObj = new Date(dates.endDate);
			}
			endDateValue = [
							  dateObj.getFullYear(),
							  ('0' + (dateObj.getMonth() + 1)).slice(-2),
							  ('0' + dateObj.getDate()).slice(-2)
							].join('-');
		}
		if(errors.length > 0){
			let errorText = "";
			setIsSubmit(false);
			for(let i=0; i < errors.length; i++){
				if(i > 0){
					errorText += "<br />";
				}
				errorText += errors[i];
			}
			setError(errorText);
			setIsSubmit(false);
		} else {
			let initialValues = {
				loginId: loginId,
				partnerCompanyId: partnerSelected.value,
				startDate: startDateValue,
				endDate: endDateValue,
			};
			handleSubmit(1, initialValues, submitComplete);
		} 

	}
	function submitCancel() {
		setError("");
		setAdd(false);
	}
	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				{partnerLoaded ? <Select
					name="companyId"
					options={partnerOptions}
					onChange={partnerHandler}
					placeholder={""}
					value={partnerSelected}
					isSearchable={true}
					isClearable={true}
					className="myselect"
					inputId="companyId-input"
					styles={ddStyles}
				/>
				: <></>}
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input
					type="date"
					name="startDate"
					id="startDate"
					value={dates.startDate || today}
					onChange={onResponseChange}
					className="form-control rounded-pill shadow-sm px-4 "
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<input
					type="date"
					name="endDate"
					id="endDate"
					value={dates.endDate}
					onChange={onResponseChange}
					className="form-control rounded-pill shadow-sm px-4 "
				/>
			</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{t("page.active")}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{(partnerOptions && partnerOptions.length > 0) ?
					(<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitRow())}>{t("page.submit")}</button>)
					:
					(<></>)
				}
				<button className={isSubmit ? "btn btn-primary btn-block me-4 mb-1 pe-none" : "btn btn-primary btn-block me-4 mb-1"} onClick={() => (submitCancel())}>{t("page.cancel")}</button>
			</td>
		</tr>
	)

}
export default UserPartnerTableRow;